import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pimg1 from '../../images/kodo/Frame 1000003556.svg'
import pimg2 from '../../images/kodo/Frame 1000003557.svg'
import pimg3 from '../../images/kodo/Frame 1000003558.svg'
import pimg4 from '../../images/kodo/Frame 1000003559.svg'
import pimg5 from '../../images/kodo/Frame 1000003560.svg'
import pimg6 from '../../images/kodo/Frame 1000003561.svg'
import pimg7 from '../../images/kodo/Frame 1000003562.svg'
import pimg8 from '../../images/kodo/Frame 1000003563.svg'
import pimg9 from '../../images/kodo/Frame 1000003564.svg'
import pimg10 from '../../images/kodo/Frame 1000003565.svg'
import pimg11 from '../../images/kodo/Frame 1000003568.svg'
import pimg12 from '../../images/kodo/Frame 1000003569.svg'
import pimg13 from '../../images/kodo/Frame 1000003570.svg'
import pimg14 from '../../images/kodo/Frame 1000003571.svg'
import pimg15 from '../../images/kodo/Frame 1000003572.svg'
import pimg16 from '../../images/kodo/Frame 1000003573.svg'
import pimg17 from '../../images/kodo/Frame 1000003574.svg'
import pimg18 from '../../images/kodo/Frame 1000003575.svg'
import pimg19 from '../../images/kodo/Frame 1000003568.svg'
import pimg20 from '../../images/kodo/Frame 1000003577.svg'

const partners = [
    {
        pImg: pimg1,
    },
    {
        pImg: pimg2,
    },
    {
        pImg: pimg3,
    },
    {
        pImg: pimg4,
    },
    {
        pImg: pimg5,
    },
    {
        pImg: pimg6,
    },
    {
        pImg: pimg7,
    },
    {
        pImg: pimg8,
    },
    {
        pImg: pimg9,
    },
    {
        pImg: pimg10,
    },
     {
        pImg: pimg11,
    },
    {
        pImg: pimg12,
    },
    {
        pImg: pimg13,
    },
    {
        pImg: pimg14,
    },
    {
        pImg: pimg15,
    },
    {
        pImg: pimg16,
    },
    {
        pImg: pimg17,
    },
    {
        pImg: pimg18,
    },
    {
        pImg: pimg19,
    },
    {
        pImg: pimg20,
    },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,

    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};



const PartnerSection = (props) => {

    return (
        <div className="client_logo_carousel">
            <Slider {...settings}>
                {partners.map((partner, pitem) => (
                    <div className="client_logo_item" key={pitem}>
                        <img src={partner.pImg} alt="Techco - Client Logo" />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default PartnerSection;